<template>
    <div class="flex flex-col gap-4">
        <div
            v-for="item in rows"
            :key="item.resourceCode"
            class="flex flex-col gap-1"
        >
            <div class="flex items-baseline justify-between gap-3 text-sm">
                <span class="font-medium text-theme-base capitalize">
                    {{ item.label }}
                </span>
                <span class="text-theme-muted">{{ item.summary }}</span>
            </div>
            <div
                v-if="item.limit !== null && item.limit > 0"
                class="h-2 w-full overflow-hidden rounded-full bg-theme-hover"
            >
                <div
                    class="h-full rounded-full"
                    :class="barClass(item)"
                    :style="{ width: `${item.percent}%` }"
                ></div>
            </div>
            <p v-if="item.isOver" class="text-xs text-theme-danger">
                Tienes {{ item.used }} de {{ item.limit }} {{ item.label }}: no
                puedes crear más hasta quedar bajo el tope.
            </p>
            <button
                v-if="item.showUpgrade"
                type="button"
                class="self-start text-xs text-theme-primary underline"
                @click="$emit('upgrade', item.upgradePlan)"
            >
                Pásate a {{ item.upgradePlan.name }}:
                {{ upgradeLimitText(item) }}
            </button>
        </div>
    </div>
</template>

<script>
const WARNING_RATIO = 0.8;

export default {
    name: "PlanUsageList",
    props: {
        // [{ resourceCode, label, used, limit, upgradePlan }] — `limit: null`
        // es sin límite; `upgradePlan` es el plan más barato que lo amplía.
        items: {
            type: Array,
            default: () => []
        }
    },
    emits: ["upgrade"],
    computed: {
        rows() {
            return this.items.map((item) => {
                const unlimited = item.limit === null;
                const isOver = !unlimited && item.used > item.limit;
                const ratio =
                    unlimited || item.limit === 0 ? 0 : item.used / item.limit;
                const notIncluded = !unlimited && item.limit === 0;
                return {
                    ...item,
                    isOver,
                    percent: Math.min(100, Math.round(ratio * 100)),
                    summary: unlimited
                        ? `${item.used} · sin límite`
                        : notIncluded
                        ? "No incluido en tu plan"
                        : `${item.used} de ${item.limit}`,
                    showUpgrade:
                        Boolean(item.upgradePlan) &&
                        (notIncluded || isOver || ratio >= WARNING_RATIO)
                };
            });
        }
    },
    methods: {
        barClass(item) {
            if (item.isOver) return "bg-theme-danger";
            if (item.percent >= WARNING_RATIO * 100) return "bg-theme-warning";
            return "bg-theme-primary";
        },
        upgradeLimitText(item) {
            return item.upgradePlan.limit === null
                ? `${item.label} sin límite`
                : `${item.upgradePlan.limit} ${item.label}`;
        }
    }
};
</script>
